import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {ApiClientConfig} from './api-client-config';

@Injectable({
  providedIn: 'root'
})
export class QueryService {

  private readonly endpoint: string;

  constructor(@Inject(ApiClientConfig) private config: ApiClientConfig,
              private httpClient: HttpClient) {
    this.endpoint = this.config.endPoint + `/api/org`;
  }

  public resolve(query?: unknown): Observable<unknown[]> {
    if (!query) {
      console.error('Ignored resolve without query');
      return of([])
    } else {
      const url = this.endpoint + `/queries/resolve`;
      return this.httpClient.post<unknown[]>(url, query);
    }

  }

}
